const applyEventAction = (data, action) => {
  let changed = false;
  switch (action.action) {
    case "addTag": {
      if (!data.tags) {
        data.tags = [];
      }
      if (data.tags.indexOf(action.value) < 0) {
        data.tags.push(action.value);
        changed = true;
      }
      break;
    }
    case "removeTag": {
      if (!data.tags || !data.tags.length) {
        return false;
      }
      const index = data.tags.indexOf(action.value);
      if (index >= 0) {
        data.tags.splice(index, 1);
        changed = true;
      }
      break;
    }
  }
  return changed;
};
const isValidEvent = (event) => {
  return event.type == "userAction" && event.targetIds?.length && event.actions?.length;
};
const applyEventDate = (entry, event) => {
  if (!event.date) {
    return;
  } else if (!entry.updated || entry.updated < event.date) {
    entry.updated = event.date;
  }
};
const idMapReducer = (result, entry) => {
  const id = entry.id;
  if (!result[id]) {
    result[entry.id] = [entry];
  } else {
    result[id].push(entry);
  }
  return result;
};
const flattenReducer = (result, entry) => {
  result.push(...entry);
  return result;
};
const applyEvents = (entries, events) => {
  const id2Entries = entries.reduce(idMapReducer, {});
  const changedEntries = [];
  events.filter(isValidEvent).forEach((event) => {
    const eventId = event.id;
    const targetEntries = event.targetIds.filter((entryId) => id2Entries[entryId]?.length).map((entryId) => id2Entries[entryId]).reduce(flattenReducer, []).filter((entry) => !entry.appliedEventIds || entry.appliedEventIds.indexOf(eventId) < 0);
    targetEntries.forEach((entry) => {
      let changed = false;
      event.actions.forEach((action) => {
        changed = applyEventAction(entry, action) || changed;
      });
      if (!entry.appliedEventIds) {
        entry.appliedEventIds = [];
      }
      entry.appliedEventIds.push(event.id);
      if (changed) {
        if (!changedEntries.includes(entry)) {
          changedEntries.push(entry);
        }
        applyEventDate(entry, event);
      }
    });
  });
  return changedEntries;
};
export {
  applyEvents
};
//# sourceMappingURL=apply-events.js.map
